// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"009ffb82","787":"f216ee4f","983":"a49b8253"}[chunkId] + ".chunk.js";
};